import { render, staticRenderFns } from "./EmbellishmentAdd.vue?vue&type=template&id=59be1dc0&"
import script from "./EmbellishmentAdd.vue?vue&type=script&lang=js&"
export * from "./EmbellishmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports